const MAINENANCE_MODE_STATUS = 503;

const isMaintenanceApiGraphQlError = (graphQLError) =>
  graphQLError?.extensions?.response?.status === MAINENANCE_MODE_STATUS;

const MAINENANCE_MODE_MESSAGE = '503: Service Unavailable';

export default function isMaintenanceError(error) {
  // this covers generic 503 cases
  if (error.message === MAINENANCE_MODE_MESSAGE) return true;
  return error.graphQLErrors?.some(isMaintenanceApiGraphQlError);
}
